import React from "react";
import { FiArrowUpRight, FiCalendar } from "react-icons/fi";
import { Link } from "react-router-dom";

const BudgetCard = () => {
  return (
    <div className="card custom-card h-100">
      <div className="card-body">

        {/* TOP */}
        <div className="top-section">
          <div className="icon-wrapper">
            <img
              src="/assets/img/icons/title-icon-01.svg"
              alt=""
              className="icon"
            />
            <img
              src="/assets/img/bg/title-bg-01.png"
              alt=""
              className="bg-icon"
            />
          </div>
<Link to="/budget-page"   >
<button  className="arrow-btn" >
            <FiArrowUpRight />
          </button>
</Link>
          
        </div>

        {/* TITLE + UPDATE */}
        <div className="middle-section">
          <div>
            <p className="title">Budget Remaining</p>
            <h2 className="amount">
              $2,458,900
              <span className="up-badge">▲</span>
            </h2>
          </div>


          <div className="update-pill">
            <FiCalendar /> Updated : 15 Jan 2025
          </div>
        </div>

        {/* PROGRESS */}
        <div className="progress-section">
          <div className="progress-item">
            <p>Salary Budget</p>
            <div className="progress orange"></div>
            <span>$1,229,450</span>
          </div>

          <div className="progress-item">
            <p>Benefits</p>
            <div className="progress teal"></div>
            <span>$491,780</span>
          </div>

          <div className="progress-item">
            <p>HR Operations</p>
            <div className="progress dark"></div>
            <span>$737,670</span>
          </div>
        </div>

      </div>

      {/* CSS */}
      <style>{`
        .custom-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        /* TOP */
        .top-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .icon-wrapper {
          position: relative;
          width: 50px;
          height: 50px;
        }

        .icon {
          width: 32px;
          position: relative;
          z-index: 2;
        }

        .bg-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          opacity: 0.2;
        }

        /* 🔥 ORANGE BUTTON */
        .arrow-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: #e5e2e0;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ea580c;
          transition: 0.3s;
        }
          

        .arrow-btn:hover {
          background: #ea580c;
          color: #ffffff;

        }

        /* MIDDLE */
        .middle-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 15px;
        }

        .title {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 4px;
        }

        .amount {
          font-size: 28px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .up-badge {
          background: #22c55e;
          color: #fff;
          font-size: 12px;
          border-radius: 50%;
          padding: 4px 6px;
        }

        .update-pill {
          border: 1px solid #e5e7eb;
          border-radius: 20px;
          padding: 5px 10px;
          font-size: 13px;
          color: #555;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* PROGRESS */
        .progress-section {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 15px;
        }

        .progress-item p {
          font-size: 13px;
          margin-bottom: 6px;
        }

        .progress {
          height: 12px;
          border-radius: 20px;
          margin-bottom: 6px;
          position: relative;
          overflow: hidden;
        }

        /* STRIPES */
        .progress::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background-image: repeating-linear-gradient(
            45deg,
            rgba(255,255,255,0.2) 0,
            rgba(255,255,255,0.2) 10px,
            transparent 10px,
            transparent 20px
          );
        }

        .orange { background: #ff7a2f; }
        .teal { background: #1f6f78; }
        .dark { background: #2d2d2d; }

        .progress-item span {
          font-size: 14px;
          color: #374151;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .progress-section {
            grid-template-columns: 1fr;
          }

          .middle-section {
            flex-direction: column;
            align-items: flex-start;
          }

          .arrow-btn {
            width: 34px;
            height: 34px;
          }
        }
      `}</style>
    </div>
  );
};

export default BudgetCard;